import React from 'react';
import { ArrowDownIcon, LockIcon } from 'lucide-react';
import { CHECKOUT_URL, OFFER_ANCHOR, PRODUCT_PRICE } from '../data/config';
import { trackPixel } from '../utils/pixel';
type CtaButtonProps = {
  children: React.ReactNode;
  mode: 'checkout' | 'scroll';
  subtext?: string;
  className?: string;
};
export function CtaButton({
  children,
  mode,
  subtext,
  className = 'max-w-[448px]'
}: CtaButtonProps) {
  const isCheckout = mode === 'checkout';
  const Icon = isCheckout ? LockIcon : ArrowDownIcon;
  return <a href={isCheckout ? CHECKOUT_URL : OFFER_ANCHOR} onClick={() => isCheckout && trackPixel('InitiateCheckout', {
    value: PRODUCT_PRICE,
    currency: 'USD'
  })} className={`mx-auto flex min-h-[50px] w-full flex-col items-center justify-center rounded-md bg-amber-400 px-4 py-2.5 text-center text-blue-950 shadow-[0_4px_0_theme(colors.amber.700)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-amber-300 active:translate-y-[2px] active:shadow-[0_2px_0_theme(colors.amber.700)] focus:outline-none focus-visible:ring-4 focus-visible:ring-teal-700/40 ${className}`} data-id="element-43" data-mp="lkflyr8hvu3k">
      <span className="flex items-center gap-2 text-[15px] font-extrabold uppercase leading-tight md:text-[18px]" data-id="element-44" data-mp="39z9huv84d90y">
        <Icon className="h-[18px] w-[18px] shrink-0" strokeWidth={2.75} aria-hidden data-id="element-45" data-mp="3ezxb7njtm1yc" />
        <span className="text-balance" data-id="element-46" data-mp="3jy8jvuydq6ez">{children}</span>
      </span>
      {subtext && <span className="mt-1 text-[11px] font-semibold leading-tight" data-id="element-47" data-mp="3ov8sacipbl99">{subtext}</span>}
    </a>;
}